import Tabs from './Tabs'
export default Tabs



// WEBPACK FOOTER //
// ./components/Tabs/index.js